import Piano from '../piano';

const keys = [
  { name: '--', value: undefined },
  { name: 'C', value: 60 },
  { name: 'C#', value: 61 },
  { name: 'D', value: 62 },
  { name: 'D#', value: 63 },
  { name: 'E', value: 64 },
  { name: 'F', value: 65 },
  { name: 'F#', value: 66 },
  { name: 'G', value: 67 },
  { name: 'G#', value: 68 },
  { name: 'A', value: 69 },
  { name: 'A#', value: 70 },
  { name: 'B', value: 71 }
];

const flavours = [
  { name: '--', value: undefined },
  { name: 'dur', value: 'dur' },
  { name: 'm', value: 'moll' },
  { name: 'sus2', value: 'sus2' },
  { name: 'sus', value: 'sus' },
  { name: '7sus4', value: '7sus4' },
  { name: '5+', value: 'aug5' },
  { name: 'm5+', value: 'maug5' },
  { name: 'm-5', value: 'mm5' },
  { name: 'm7-5', value: 'm7m5' },
  { name: '6', value: '6' },
  { name: 'm6', value: 'm6' },
  { name: '7', value: '7' },
  { name: 'm7', value: 'm7' },
  { name: 'maj7', value: 'maj7' },
  { name: 'dim7', value: 'dim7' },
  { name: '7♭9', value: '7b9' },
  { name: '7#9', value: '7s9' },
  { name: '9', value: '9' },
  { name: 'add9', value: 'add9' },
  { name: 'maj9', value: 'maj9' },
  { name: '11', value: '11' },
  { name: 'add11', value: 'add11' },
  { name: '13', value: '13' }
];

export default {
  data () {
    return {
      key: undefined,
      flavour: undefined,
      stepThrough: false,
      keys,
      flavours
    };
  },
  computed: {
    canClearSelection () {
      return this.key || this.flavour;
    }
  },
  methods: {
    /**
     * Create a array with MIDI numbers to play for the cord.
     *
     * @param {Number} baseNote - MIDI number of the base tone in the chord.
     * @param {String} flavour - Flavour of the chord
     */
    create (baseNote, flavour) {
      // Number of baseNote+X to make cord.
      const notes = [];

      let additionValues = [];

      switch (flavour) {
      case 'dur':
        additionValues = [4, 7];
        break;
      case 'moll':
        additionValues = [3, 7];
        break;
      case 'sus2':
        additionValues = [2, 7];
        break;
      case 'sus':
        additionValues = [5, 7];
        break;
      case '7sus4':
        additionValues = [5, 7, 10];
        break;
      case 'aug5':
        additionValues = [4, 8];
        break;
      case 'maug5':
        additionValues = [3, 8];
        break;
      case 'mm5':
        additionValues = [3, 6];
        break;
      case 'm7m5':
        additionValues = [3, 6, 10];
        break;
      case '6':
        additionValues = [4, 7, 9];
        break;
      case 'm6':
        additionValues = [3, 7, 9];
        break;
      case '7':
        additionValues = [4, 7, 10];
        break;
      case 'm7':
        additionValues = [3, 7, 10];
        break;
      case '7b9':
        additionValues = [4, 7, 10, 13];
        break;
      case '7s9':
        additionValues = [4, 7, 10, 15];
        break;
      case 'maj7':
        additionValues = [4, 7, 11];
        break;
      case 'dim7':
        additionValues = [3, 6, 9];
        break;
      case '9':
        additionValues = [4, 7, 10, 14];
        break;
      case 'add9':
        additionValues = [4, 7, 14];
        break;
      case 'maj9':
        additionValues = [4, 7, 11, 14];
        break;
      case '11':
        additionValues = [4, 5, 7, 10, 14];
        break;
      case 'add11':
        additionValues = [4, 5, 7];
        break;
      case '13':
        additionValues = [4, 5, 7, 9, 10, 14];
        break;
      default: break;
      }

      // Midi numbers in the chord
      notes.push(baseNote);

      for (let i = 0; i < additionValues.length; i++) {
        notes.push(baseNote + additionValues[i]);
      }

      return notes;
    },

    clearChordStyles () {
      const allChordedKeys = document.querySelectorAll('.key.chorded');

      for (let i = 0; i < allChordedKeys.length; i++) {
        allChordedKeys[i].classList.remove('chorded');
      }
    },

    clearChordSelect () {
      this.key = undefined;
      this.flavour = undefined;

      this.clearChordStyles();
    },

    disable () {
      this.$el.classList.add('disabled');
    },

    enable () {
      this.$el.classList.remove('disabled');
    },

    playChord () {
      const chordKeySelect = parseInt(this.key, 10);
      const chordFlavourSelect = this.flavour;

      this.clearChordStyles();

      if (isNaN(chordKeySelect)) {
        this.clearChordSelect();

        return;
      }

      this.disable();

      const chord = this.create(chordKeySelect, chordFlavourSelect);

      Piano.playChord(chord, this.stepThrough)
        .then(this.enable);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/chord-selector/chord-selector.js